import { ROUTES } from '@/constants/routes'

export const PAY_MODULE_REFERRER_KEY = 'pay_module_referrer'

const getBasePath = () => (import.meta.env.VITE_BASE_PATH || '/cashloan').replace(/\/$/, '')

/** Absolute dashboard URL used as payment return / PG router referrer. */
export const getPaymentReturnUrl = () => {
  if (typeof window === 'undefined') return ''
  return `${window.location.origin}${getBasePath()}${ROUTES.DASHBOARD}`
}

/** PAY API subScreen key for the review sheet, from sections item meta.payment_type. */
export const getReviewSubScreenKey = paymentType => {
  const normalized = String(paymentType ?? '')
    .trim()
    .toLowerCase()
  if (normalized === 'min') return 'min_due_bottomsheet'
  return 'max_due_bottomsheet'
}

const isEmpty = value =>
  value == null || (typeof value === 'object' && Object.keys(value).length === 0)

/** Keys rendered as hidden inputs on the PayU POST form (excludes routing/meta fields). */
export const getPayuFormFieldKeys = transact =>
  Object.keys(transact || {}).filter(
    key =>
      key !== 'payment_url' &&
      key !== 'transaction_details' &&
      key !== 'use_payufin_web_module' &&
      (typeof transact[key] === 'string' || typeof transact[key] === 'number')
  )

/**
 * PG Router: navigate to /payment with txn query params.
 * Legacy PayU: returns true so the caller can submit the hidden POST form.
 */
export const processTransactResponse = (transactionData, navigate) => {
  if (isEmpty(transactionData)) {
    return { handled: false }
  }

  if (transactionData.transaction_details) {
    const { txnId, clientId } = transactionData.transaction_details

    if (txnId) {
      const finalTenant = 'payufin'

      try {
        sessionStorage.setItem(PAY_MODULE_REFERRER_KEY, encodeURIComponent(getPaymentReturnUrl()))
      } catch {
        // sessionStorage may be unavailable; PayModule falls back to dashboard URL
      }

      const params = new URLSearchParams({ txnId })
      if (clientId) params.set('clientId', clientId)
      if (finalTenant) params.set('tenant', finalTenant)

      navigate(`${ROUTES.PAYMENT}?${params.toString()}`)
      return { handled: true, type: 'pgrouter' }
    }
  } else if (transactionData.payment_url) {
    return { handled: true, type: 'payment_url' }
  }

  return { handled: false }
}
